import { ZonedDate } from '@progress/kendo-date-math';
/** @hidden */
export var toRanges = function (dateRange, _a) {
    var step = _a.step, timezone = _a.timezone;
    var ranges = [];
    var zonedRangeStart = ZonedDate.fromLocalDate(dateRange.start, timezone);
    var zonedRangeEnd = ZonedDate.fromLocalDate(dateRange.end, timezone);
    for (var current = zonedRangeStart.clone(), index = 0; current.getTime() < zonedRangeEnd.getTime(); index++, current = current.addTime(step)) {
        var zonedStart = current.clone();
        var zonedEnd = zonedStart.clone().addTime(step);
        var start = new Date(zonedStart.getTime());
        var end = new Date(zonedEnd.getTime());
        var range = {
            index: index,
            end: end,
            start: start,
            zonedStart: zonedStart,
            zonedEnd: zonedEnd
        };
        ranges.push(range);
    }
    return ranges;
};
//# sourceMappingURL=rangeService.js.map